


























import { Teacher } from '../../../src_server/entity/generated/Teacher';
import { Vue, Component, Prop } from 'vue-property-decorator';
import CommonDialog from '../../components/organisms/CommonDialog.vue';
import { TeacherService } from '../../biz/remote/TeacherService';
import { MessageDialog } from '../../utils/MessageDialog';
@Component({ components: { CommonDialog } })
export default class TeacherInteviewDialog extends Vue {
  private info = new Teacher();

  get model() {
    return this.info.interview_url || '';
  }

  set model(value: string) {
    this.info.interview_url = value;
    const biz = new TeacherService();
    biz.updateTeacher(this.info).then(async () => {
      await MessageDialog.alert(`ドキュメントURLを保存しました`);
    });
  }

  /**
   * 表示
   */
  public show(row: Teacher) {
    this.info = row;
    const dialog = this.$refs['interview_dialog'] as CommonDialog;
    dialog.show();
  }

  /**
   * 隠す
   */
  hide() {
    const dialog = this.$refs['interview_dialog'] as CommonDialog;
    dialog.hide();
  }

  openNewWindow() {
    window.open(this.info.interview_url, 'interviewdoc');
  }
}
